module.exports = __webpack_public_path__ + "img/model2.69e3f556.png";